export default __webpack_public_path__ + "static/media/arrow-back.fe100d52.svg";